import { StickyActionElement } from "@omni/types/components/general/enums/stickyActionElement.enum";
import { Badge } from "@omni/ui/components/Badge/badge.component";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useProductComparisonBarContext } from "@/components/Product/ProductComparisonBar/context/productComparisonBar.context";
import { StickyAction } from "@/components/StickyAction/stickyAction";
import { PRODUCT_COMPARISON_MAX_SKUS } from "@/redux/modules/value/productComparisonSkuList/productComparisonSkuList.config";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type TriggerProps = {
    className?: string;
};

const Trigger = ({ className }: TriggerProps) => {
    const { t } = useGranite();

    const { open, products, toggle } = useProductComparisonBarContext();

    return (
        <StickyAction
            stickyActionElement={StickyActionElement.ComparisonButton}
        >
            <Button
                type={"button"}
                onClick={toggle}
                size={"md"}
                className={cn(
                    "tw:ring-0! tw:w-full tw:md:rounded-b-none! tw:md:w-100 tw:md:mr-4",
                    className
                )}
            >
                <i
                    className={cn("las", "tw:mr-2", {
                        "la-angle-down": open,
                        "la-angle-up": !open
                    })}
                />
                <span className="tw:inline-block tw:md:hidden">
                    {t("productComparison.compare.short")}
                </span>
                <span className="tw:hidden tw:md:inline-block">
                    {t("productComparison.compare")}
                </span>
                <Badge
                    inverse={true}
                    className={cn("tw:ml-2 tw:hidden tw:md:inline-block")}
                >
                    {products?.length || 0}/{PRODUCT_COMPARISON_MAX_SKUS}
                </Badge>
            </Button>
        </StickyAction>
    );
};

export { Trigger };
